import dayjs from "dayjs";
import React, { useRef, useState } from "react";
import { usePDF } from 'react-to-pdf';
import DateComp from "../../../../core/common/dateComponent/DateComp";
import { svgIcons } from "../../../../style/fonts/SvgIcons";
import { toast } from "react-toastify";
import FormattedNumber from "../../../../core/common/textFields/FormatNumber";
import { Link } from "react-router-dom";

const UserInfoCard = ({ isCollapsed, handleShowInfoCard, clientViewSummary, projectByIdData }: any) => {


    const cardRefLeadInfo = useRef<HTMLDivElement>(null);

    const handleCopyLeadInfo = () => {
        if (cardRefLeadInfo.current) {
            const htmlContent = cardRefLeadInfo.current.innerHTML;
            navigator.clipboard.writeText(htmlContent).then(() => {
                toast("Copied to clipboard!");
            }).catch(err => console.error("Failed to copy:", err));
        }
    };

    const cardRefJobInfo = useRef<HTMLDivElement>(null);

    const handleCopyJobInfo = () => {
        if (cardRefJobInfo.current) {
            const htmlContent = cardRefJobInfo.current.innerHTML;
            navigator.clipboard.writeText(htmlContent).then(() => {
                toast("Copied to clipboard!");
            }).catch(err => console.error("Failed to copy:", err));
        }
    };
    const cardRefFinanceInfo = useRef<HTMLDivElement>(null);

    const handleCopyFinanceInfo = () => {
        if (cardRefFinanceInfo.current) {
            const htmlContent = cardRefFinanceInfo.current.innerHTML;
            navigator.clipboard.writeText(htmlContent).then(() => {
                toast("Copied to clipboard!");
            }).catch(err => console.error("Failed to copy:", err));
        }
    };

    return (
        <div className="d-flex mt-5">

            {/* Sidebar */}
            <div
                className={`bg-light p-2 mt-3 ${isCollapsed ? "collapsed-sidebar" : "expanded-sidebar"
                    }`}
                style={{
                    width: isCollapsed ? "40px" : "300px",
                    transition: "width 0.3s ease",
                    height: "100vh",
                    overflowY: 'auto',
                    overflowX: 'hidden'
                }}
            >
                <button className="" onClick={handleShowInfoCard} style={{ border: '0px', backgroundColor: 'transparent' }}>
                    {isCollapsed ?
                        <i className=" fw-500 fs-20 ti ti-arrow-bar-to-left">
                        </i>
                        :
                        <i className=" fw-500 fs-20 ti ti-arrow-bar-to-right">
                        </i>
                    }
                </button>

                {!isCollapsed && (
                    <>
                        <div className="content">
                            {/* <div className="row">
                                <div className="col-md-12 mt-4">
                                    <div className="profile-pic-upload ">
                                        <div className="profile-pic">
                                            <img
                                                src={'/assets/img/profiles/default-upload-img.svg'}
                                                alt="img"
                                                className="preview1"
                                            />
                                        </div>
                                        <div className="d-flex flex-column">
                                            <button className="btn btn-primary fs-11 "  >
                                                Contact Info
                                            </button>
                                            <button className="btn btn-primary fs-11 mt-2" >
                                                Assignment Info
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div> */}
                            <div className="row">
                                <div className="col-md-12 mt-1">
                                    <div className="card">
                                        <div className="card-body card-css p-2">
                                            <div className="d-flex justify-content-between">
                                                <h6 className="color-red mb-3">Lead Info Summary</h6>
                                                <div className="cursor-pointer" onClick={handleCopyLeadInfo}>
                                                    {svgIcons.CopyIcon}
                                                </div>
                                            </div>
                                            <div ref={cardRefLeadInfo} >
                                                <div className="d-flex mb-1 align-items-center  ">
                                                    <p className="w-40 mb-0">
                                                        Client:
                                                    </p>
                                                    <p className=" w-60 mb-0">
                                                        <Link to={`/contacts/ViewContacts/${projectByIdData?.result?.contactId}`} className='color-red'> {clientViewSummary?.result?.leadInfo?.contactName}</Link>
                                                    </p>

                                                </div>
                                                <div className="d-flex mb-1 align-items-center ">
                                                    <p className="w-40 mb-0">
                                                        Secondary Contact:
                                                    </p>
                                                    <p className="w-60 mb-0">
                                                        {clientViewSummary?.result?.leadInfo?.secondaryContactId
                                                            ? (
                                                                <Link
                                                                    to={`/contacts/ViewContacts/${clientViewSummary?.result?.leadInfo?.secondaryContactId}`}
                                                                    className='color-red'
                                                                >
                                                                    {clientViewSummary?.result?.leadInfo?.secondaryContactName}
                                                                </Link>
                                                            )
                                                            : clientViewSummary?.result?.leadInfo?.secondaryContactName
                                                        }
                                                    </p>
                                                </div>
                                                <div className="d-flex mb-1 ">
                                                    <p className="w-40 mb-0">
                                                        Status:
                                                    </p>
                                                    <p className="mb-0 w-60">
                                                        {clientViewSummary?.result?.leadInfo?.projectStatus}
                                                    </p>
                                                </div>
                                                <div className="d-flex mb-1 ">
                                                    <p className="w-40 mb-0">
                                                        Cell Ph:
                                                    </p>
                                                    <p className="mb-0 w-60">
                                                        {clientViewSummary?.result?.leadInfo?.cellPhone}
                                                    </p>
                                                </div>
                                                <div className="d-flex mb-1  ">
                                                    <p className=" w-40 mb-0">
                                                        Address:
                                                    </p>
                                                    <p className="mb-0 w-60">
                                                        {clientViewSummary?.result?.leadInfo?.address}
                                                    </p>
                                                </div>
                                                <div className="d-flex mb-1 ">
                                                    <p className="w-40 mb-0">
                                                        Work Email:
                                                    </p>
                                                    <p className="mb-0 w-60">
                                                        {clientViewSummary?.result?.leadInfo?.workEmail}

                                                    </p>
                                                </div>
                                                <div className="d-flex mb-1 ">
                                                    <p className="w-40 mb-0">
                                                        Home Email:
                                                    </p>
                                                    <p className="mb-0 w-60">
                                                        {clientViewSummary?.result?.leadInfo?.homeEmail}

                                                    </p>
                                                </div>
                                                <div className="d-flex mb-1 ">
                                                    <p className=" w-40 mb-0">
                                                        Sales Repres.. :
                                                    </p>
                                                    <p className="mb-0 w-60">
                                                        {clientViewSummary?.result?.leadInfo?.salesRep}

                                                    </p>
                                                </div>
                                                <div className="d-flex mb-1 ">
                                                    <p className="w-40 mb-0">
                                                        Last GoBack:
                                                    </p>
                                                    <p className="mb-0 w-60">
                                                        <DateComp formattedDate={clientViewSummary?.result?.leadInfo?.lastGoBack} />
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-12 mt-3">
                                    <div className="card">
                                        <div className="card-body card-css p-2">
                                            <div className="d-flex justify-content-between">
                                                <h6 className="color-red mb-3">Job Info Summary</h6>
                                                <div className="cursor-pointer" onClick={handleCopyJobInfo}>
                                                    {svgIcons.CopyIcon}
                                                </div>
                                            </div>
                                            <div ref={cardRefJobInfo} >
                                                {/* <div className="d-flex mb-1 ">
                                                    <p className="w-40 mb-0">
                                                        Job Name:
                                                    </p>
                                                    <p className="mb-0 w-60">
                                                        {clientViewSummary?.result?.jobInfo?.jobName}
                                                    </p>

                                                </div> */}
                                                <div className="d-flex mb-1 align-items-center  ">
                                                    <p className="w-40 mb-0">
                                                        Job Name:
                                                    </p>
                                                    <p className=" w-60 mb-0">
                                                        {clientViewSummary?.result?.jobInfo?.jobName}
                                                    </p>

                                                </div>
                                                <div className="d-flex mb-1 ">
                                                    <p className="w-40 mb-0">
                                                        Job#:
                                                    </p>
                                                    <p className="mb-0 w-60">
                                                        {clientViewSummary?.result?.jobInfo?.jobNo !== null ? clientViewSummary?.result?.jobInfo?.jobNo : ''}
                                                    </p>
                                                </div>
                                                <div className="d-flex mb-1 ">
                                                    <p className="w-40 mb-0">
                                                        BU Sales:
                                                    </p>
                                                    <p className="mb-0 w-60">
                                                        {clientViewSummary?.result?.jobInfo?.buSales}
                                                    </p>
                                                </div>
                                                <div className="d-flex mb-1">
                                                    <p className="mb-0 w-40">
                                                        BU Project Dev:
                                                    </p>
                                                    <p className="mb-0 w-60">
                                                        {clientViewSummary?.result?.jobInfo?.buProjectDev}

                                                    </p>
                                                </div>
                                                <div className="d-flex mb-1 ">
                                                    <p className="w-40 mb-0">
                                                        BU Production:
                                                    </p>
                                                    <p className="mb-0 w-60">
                                                        {clientViewSummary?.result?.jobInfo?.buProd}
                                                    </p>
                                                </div>
                                                <div className="d-flex mb-1">
                                                    <p className="w-40 mb-0">
                                                        Job Desc:
                                                    </p>
                                                    <p className=" w-60 mb-0 h-25 overflow-auto">
                                                        {clientViewSummary?.result?.jobInfo?.jobDesc}
                                                    </p>
                                                </div>
                                                <div className="d-flex mb-1 align-items-center">
                                                    <p className="mb-0 w-40">
                                                        Total Contract Amt:
                                                    </p>
                                                    <p className="mb-0 w-60">
                                                        <FormattedNumber value={clientViewSummary?.result?.jobInfo?.totalContractAmount} />
                                                    </p>
                                                </div>
                                                <div className="d-flex mb-1">
                                                    <p className="mb-0 w-40">
                                                        Sale Dt:
                                                    </p>
                                                    <p className="mb-0 w-60">
                                                        <DateComp formattedDate={clientViewSummary?.result?.jobInfo?.saleDate} />
                                                    </p>
                                                </div>
                                                <div className="d-flex mb-1 ">
                                                    <p className="w-40 mb-0">
                                                        Acc Dt:
                                                    </p>
                                                    <p className="mb-0 w-60">
                                                        <DateComp formattedDate={clientViewSummary?.result?.jobInfo?.acceptedDate} />
                                                    </p>
                                                </div>
                                                <div className="d-flex mb-1 ">
                                                    <p className="w-40 mb-0">
                                                        Dwn Pmt:
                                                    </p>
                                                    <p className="mb-0 w-60">
                                                        <FormattedNumber value={clientViewSummary?.result?.jobInfo?.downPayment} />
                                                    </p>
                                                </div>
                                                <div className="d-flex mb-1 ">
                                                    <p className="w-40 mb-0">
                                                        Rev by:
                                                    </p>
                                                    <p className="mb-0 w-60">
                                                        {clientViewSummary?.result?.jobInfo?.reviewedBy}
                                                    </p>
                                                </div>
                                                <div className="d-flex mb-1 ">
                                                    <p className="w-40 mb-0">
                                                        Warr Exc:
                                                    </p>
                                                    <p className="mb-0 w-60">
                                                        {clientViewSummary?.result?.jobInfo?.warrEx ? clientViewSummary?.result?.jobInfo?.warrEx : 'No'}
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-12 mt-3">
                                    <div className="card">
                                        <div className="card-body card-css p-2">
                                            <div className="d-flex justify-content-between">
                                                <h6 className="color-red mb-3">Finance Info Summary</h6>
                                                <div className="cursor-pointer" onClick={handleCopyFinanceInfo}>
                                                    {svgIcons.CopyIcon}
                                                </div>
                                            </div>
                                            <div ref={cardRefFinanceInfo} >
                                                <div className="d-flex mb-1 ">
                                                    <p className="w-40 mb-0">
                                                        Loan Amount:
                                                    </p>
                                                    <p className="mb-0 w-60">
                                                        {clientViewSummary?.result?.financeInfo?.loanAmount ? clientViewSummary?.result?.financeInfo?.loanAmount?.toLocaleString() : '$0.00'}
                                                    </p>
                                                </div>
                                                <div className="d-flex mb-1 ">
                                                    <p className="w-40 mb-0">
                                                        Financed?:
                                                    </p>
                                                    <p className="mb-0 w-60">
                                                        {clientViewSummary?.result?.financeInfo?.financed === true ? 'Yes' : 'No'}
                                                    </p>
                                                </div>
                                                <div className="d-flex mb-1 ">
                                                    <p className="w-40 mb-0">
                                                        Cash?:
                                                    </p>
                                                    <p className="mb-0 w-60">
                                                        {clientViewSummary?.result?.financeInfo?.cash === true ? 'Yes' : 'No'}

                                                    </p>
                                                </div>
                                                <div className="d-flex mb-1 ">
                                                    <p className="w-40 mb-0">
                                                        Owner Bank?:
                                                    </p>
                                                    <p className="mb-0 w-60">
                                                        {clientViewSummary?.result?.financeInfo?.ownerBank === true ? 'Yes' : 'No'}
                                                    </p>
                                                </div>
                                                <div className="d-flex mb-1 ">
                                                    <p className="w-40 mb-0">
                                                        Using Lamb?:
                                                    </p>
                                                    <p className="mb-0 w-60">
                                                        {clientViewSummary?.result?.financeInfo?.usingLamb === true ? 'Yes' : 'No'}
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </>
                )}
            </div>
        </div>
    );
};

export default UserInfoCard;
